/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-29 16:22:07
 * @LastEditors: liuziwei
 * @Description: 首页领券 banner
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view wx:if="{{isShowCoupon}}" class="coupon-banner-container">
    <!-- 卡片 & 标题部分 -->
    <card-frame class="card-frame" style="{{backStyle}}" cardConf="{{cardConf}}" bind:clickExtra="clickExtra">
      <!-- 券组件部分 -->
      <banner activityId="{{activityId}}" newCoustomer="{{newCoustomer}}" couponList="{{allCoupons}}" bind:clickExtra="clickExtra"/>
    </card-frame>
    <!-- 浮层部分 -->
    <drawer-frame
      title="{{title}}"
      useTab="{{useTab}}"
      curTab="{{curTab}}"
      showPackDetail="{{showPackDetail}}"
      leftTitle="{{true}}"
      open="{{openDrawer}}"
      customStyle="{{drawerCusStyle}}"
      bind:closeDrawer="closeDrawer"
      bind:changeCurTab="changeCurTab"
      bind:hidePackDetail="changeShowPackDetail"
    >
      <view slot="titleSlot" class="explain" bindtap="clickCouponRules">规则说明</view>
      <!-- 券列表部分 -->
      <coupon-list
        wx:if="{{showCouponTab}}"
        received="{{received}}"
        unclaimed="{{unclaimed}}"
        activityId="{{activityId}}"
        bannerFrom="{{bannerFromConf.home}}"
      />
      <package-list
        wx:elif="{{!showCouponTab && !showPackDetail}}"
        bannerFrom="{{bannerFromConf.home}}"
        bind:showPackDetail="changeShowPackDetail"
      />
      <package-usage-list wx:else />
    </drawer-frame>
  </view>
</template>

<script>
  import store from '@/store'
  import { createComponent } from '@didi/es-mpx-creator'
  import { bannerFromConf } from '@/config/coupon'
  import { watchEvent } from '@/utils'
  import { locate, goTo } from '@didi/webx-js'
  import { trackEvent } from '@/common/track'
  import { debounce } from '@/utils'
  import { NOT_FIRST_SEEN_ACC_PACK } from '@/utils/train-storage'
  import { setStorage } from '@/utils/storage'

  createComponent({
    props: {
      useTab: {
        type: Boolean,
        value: false
      }
    },
    data: {
      // drawer 展开状态
      openDrawer: false,
      curTab: 'coupon',
      showPackDetail: false,
      bannerFromConf
    },
    async attached() {
      const locationInfo = await locate?.({ useQuickOption: 'city' })
      // 获取券列表数据
      this.getCouponData({ city_id: locationInfo?.cityId ?? -1 })
      // 监听优惠券更新事件
      watchEvent('updateCoupon', () => {
        this.getCouponData()
      })
    },
    computed: {
      ...store.mapState({
        couponData: 'coupon.couponData'
      }),
      // 卡片配置
      cardConf() {
        const isNewCustomer = this.couponData?.new_customer
        return {
          title: {
            newCustomerIcon: isNewCustomer ? 'https://ut-static.udache.com/webx/sfc/Oa1bIJDxl0CwJO6fpasSB.png' : '',
            newCustomerText: isNewCustomer ? '可以享受以下新人专属权益' : '',
            text: isNewCustomer ? '' : '天天领福利',
            color: '#000'
          },
          extra: {
            text: isNewCustomer ? '前往查看' : (this.couponData?.coupon_desc ?? '立即领取'),
            color: '#FF4129'
          }
        }
      },
      // pope 活动 id
      activityId() {
        return this.couponData?.activity_id ?? ''
      },
      newCoustomer() {
        return this.couponData?.new_customer ?? false
      },
      // 已领取的券
      received() {
        return this.couponData?.stock_coupons_info ?? []
      },
      // 未领取的券
      unclaimed() {
        // 未领取 + 活动券
        const coupon = this.couponData?.coupons_info.concat(this.couponData?.cyber_set_coupons)
        return coupon ?? []
      },
      // 服务端去重排好序的全部券数组
      allCoupons() {
        const coupon = this.couponData?.cyber_set_coupons?.length
          ? this.couponData?.cyber_set_coupons.concat(this.couponData?.banner_coupons)
          : this.couponData?.banner_coupons
        return coupon ?? []
      },
      // 是否展示优惠券
      isShowCoupon() {
        return this.allCoupons.length
      },
      // 自定义 drawer 样式
      drawerCusStyle() {
        return { height: '592px' }
      },
      backStyle() {
        if (!this.newCoustomer) {
          return {}
        }
        return { background: `url('https://ut-static.udache.com/webx/sfc/2ilM5lQQ_aj07I5k_zzrB.png')`, backgroundSize: '100%', backgroundRepeat: 'no-repeat' }
      },
      title() {
        return this.useTab
          ? [
              { text: '优惠券', value: 'coupon' },
              { text: '加速包', value: 'package' }
            ]
          : '优惠'
      },
      showCouponTab() {
        return !this.useTab || this.curTab === 'coupon'
      }
    },
    methods: {
      ...store.mapActions({
        getCouponData: 'coupon.getCouponData'
      }),
      // 关闭 drawer
      closeDrawer({ type }) {
        if (type === 'closeDrawer') {
          this.showPackDetail = false
          this.openDrawer = false
        }
      },
      // 点击 extra 区域的回调
      clickExtra({ type,detail }) {
        // 点击 extra
        if (type === 'clickExtra') {
          if(detail === 'package'){
            this.curTab = 'package'
            trackEvent('userteam_train_coupon_banner_ck', 'UT-火车票-领券组件浮层触发入口-点击', {
              pg_type: 'speedup'
            })
          }
          if(detail === 'coupon'){
            this.curTab = 'coupon'
            trackEvent('userteam_train_coupon_banner_ck', 'UT-火车票-领券组件浮层触发入口-点击', {
              pg_type: 'coupons'
            })
          }
          if(!detail) {
            trackEvent('userteam_train_coupon_banner_ck', 'UT-火车票-领券组件浮层触发入口-点击', {
              pg_type: 'home'
            })
            this.curTab = 'coupon'
          }
          // 唤起浮层
          this.openDrawer = true
        }
      },
      changeCurTab(data) {
        const tab = data?.detail ?? ''
        if(this.curTab === tab || !tab) return 
        this.curTab = tab
        const module = this.curTab === 'coupon' ? 'coupons' : 'speedup'
        if(this.curTab === 'package') {
          setStorage({
            key: NOT_FIRST_SEEN_ACC_PACK,
            data: true
          })
        }
        trackEvent('userteam_train_homecoupon_float_tab_ck', 'UT-火车票-领券组件浮层触发入口-点击', {
          module
        })
      },
      changeShowPackDetail() {
        this.showPackDetail = !this.showPackDetail
      },
      clickCouponRules: debounce(
        function () {
          goTo({ url: 'https://v.didi.cn/YgRZxDK' })
        },
        300,
        false
      )
    }
  })
</script>

<style lang='stylus' scoped>
  .card-frame
    background #fff
    font-weight 600
    border-radius 16px
  .explain
    font-size 14px
    color #F86316
    font-weight 500
    margin-left 6px
    position relative
    &::after
      content ''
      top 9px
      right -8px
      position absolute
      width 4px
      height 4px
      border-top 1.5px solid
      border-right 1.5px solid
      transform rotate(45deg)
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      banner: './banner',
      'coupon-list': '../coupon-list',
      'card-frame': '../../card-frame',
      'drawer-frame': '../drawer-frame',
      'package-list': '@/components/package/package-list',
      'package-usage-list': '@/components/package/package-usage-list'
    }
  }
</script>
